// Make constructor globally available
window.MeetAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading Now....",
    pagination: "#infinitePagination",
    offset: 0,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.meetProductClick = this.meetProductClick.bind(this);
  this.meetProductScroll = this.meetProductScroll.bind(this);
  this.meetProductDestroy = this.meetProductDestroy.bind(this);
  this.meetStopProductMultipleClicks = this.meetStopProductMultipleClicks.bind(this);
  this.meetProductPaginationlnView = this.meetProductPaginationlnView.bind(this);

  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);

  this.meetProductInitialize();
};

// Use window.MeetAjaxForProduct.prototype everywhere
window.MeetAjaxForProduct.prototype.meetProductInitialize = function() {
  if (this.meetProductcontainer) {
    var initialidata = {
      click: this.meetProductClick,
      scroll: this.meetProductScroll,
    };
    if (initialidata[this.data.method]) {
      initialidata[this.data.method]();
    }
  }
};

window.MeetAjaxForProduct.prototype.meetProductScroll = function() {
  if (this.meetProductpagination) {
    document.addEventListener("scroll", this.meetProductPaginationlnView);
    window.addEventListener("resize", this.meetProductPaginationlnView);
    window.addEventListener("orientationchange", this.meetProductPaginationlnView);
  }
};

window.MeetAjaxForProduct.prototype.meetProductClick = function() {
  if (this.meetProductpagination) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.meetStopProductMultipleClicks);
    }
  }
};

window.MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

window.MeetAjaxForProduct.prototype.meetProductPaginationlnView = function() {
  var top = this.meetProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom = this.meetProductpagination.getBoundingClientRect().bottom + this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

window.MeetAjaxForProduct.prototype.loadMore = function() {
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  setTimeout(() => {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function() {
      if (this.request.readyState === 4 && this.request.status === 200) {
        var cratedPagination = this.request.responseXML.querySelector(this.data.pagination);
        var cratedContaner = this.request.responseXML.querySelector(this.data.container);

        if (cratedPagination) {
          this.meetProductpagination.innerHTML = cratedPagination.innerHTML;
        } else {
          this.meetProductpagination.innerHTML = ""; // Remove pagination if none left
        }

        if (cratedContaner) {
          this.meetProductcontainer.insertAdjacentHTML("beforeend", cratedContaner.innerHTML);
        }

        try {
          ((window || {}).bucksCC || {}).reConvert && bucksCC.reConvert();
        } catch (err) {
          console.warn("bucksCC.reConvert() failed:", err);
        }

        if (this.data.callback && typeof this.data.callback === "function") {
          this.data.callback(this.request.responseXML);
        }

        if (!this.request.responseXML.querySelector(`${this.data.pagination} a`)) {
          console.log("No more products to load.");
          this.removeScrollListener();
          if (loaderElement) loaderElement.style.display = "none";
        } else {
          this.meetProductInitialize();
        }
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.responseType = "document";
    this.request.send();
  }, 2000);
};

window.MeetAjaxForProduct.prototype.removeScrollListener = function() {
  document.removeEventListener("scroll", this.meetProductPaginationlnView);
  window.removeEventListener("resize", this.meetProductPaginationlnView);
  window.removeEventListener("orientationchange", this.meetProductPaginationlnView);
};

window.MeetAjaxForProduct.prototype.meetProductDestroy = function() {
  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  return this;
};

window.MeetAjaxForProduct.prototype.removeClickListener = function() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.meetStopProductMultipleClicks);
  }
};



// Modified Constructor
// window.MeetAjaxForProduct = function ajaxConstructor(settings) {
//   var default_Data = {
//     container: "#infinteLoop",
//     method: "button",
//     callback: null,
//     loadingText: "Loading Now....",
//     pagination: "#infinitePagination",
//     offset: 0,
//     buttonText: "Load More"
//   };

//   var data = settings || {};
//   this.data = Object.assign(default_Data, data);

//   this.meetProductClick = this.meetProductClick.bind(this);
//   this.meetProductDestroy = this.meetProductDestroy.bind(this);
//   this.meetStopProductMultipleClicks = this.meetStopProductMultipleClicks.bind(this);

//   // ❌ don’t cache container/pagination once
//   this.refreshSelectors();

//   this.meetProductInitialize();
// };

// // 🔄 Always refresh DOM references
// window.MeetAjaxForProduct.prototype.refreshSelectors = function() {
//   this.meetProductpagination = document.querySelector(this.data.pagination);
//   this.meetProductcontainer = document.querySelector(this.data.container);
// };

// // Init
// window.MeetAjaxForProduct.prototype.meetProductInitialize = function() {
//   if (this.meetProductcontainer && this.meetProductpagination) {
//     if (this.data.method === "button") {
//       this.meetProductClick();
//     }
//   }
// };

// // Replace scroll with button
// window.MeetAjaxForProduct.prototype.meetProductClick = function() {
//   if (this.meetProductpagination) {
//     this.nextPageLinkElement = this.meetProductpagination.querySelector("a");

//     // Clear old pagination
//     this.meetProductpagination.innerHTML = "";

//     if (this.nextPageLinkElement) {
//       this.loadMoreButton = document.createElement("button");
//       this.loadMoreButton.innerHTML = this.data.buttonText;
//       this.loadMoreButton.className = "load-more-btn";
//       this.meetProductpagination.appendChild(this.loadMoreButton);

//       this.loadMoreButton.addEventListener("click", this.meetStopProductMultipleClicks);
//     }
//   }
// };

// // Handle button click
// window.MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function(event) {
//   event.preventDefault();
//   if (this.loadMoreButton) {
//     this.loadMoreButton.disabled = true;
//     this.loadMoreButton.innerHTML = this.data.loadingText;
//   }
//   this.nextPageUrl = this.nextPageLinkElement.href;
//   this.loadMore();
// };

// // AJAX Loader
// window.MeetAjaxForProduct.prototype.loadMore = function() {
//   var loaderElement = document.getElementById("loader");
//   if (loaderElement) loaderElement.style.display = "block";

//   setTimeout(() => {
//     this.request = new XMLHttpRequest();
//     this.request.onreadystatechange = function() {
//       if (this.request.readyState === 4 && this.request.status === 200) {
//         var cratedPagination = this.request.responseXML.querySelector(this.data.pagination);
//         var cratedContaner = this.request.responseXML.querySelector(this.data.container);

//         if (cratedContaner) {
//           this.meetProductcontainer.insertAdjacentHTML("beforeend", cratedContaner.innerHTML);
//         }

//         if (this.data.callback && typeof this.data.callback === "function") {
//           this.data.callback(this.request.responseXML);
//         }

//         if (cratedPagination && cratedPagination.querySelector("a")) {
//           this.nextPageLinkElement = cratedPagination.querySelector("a");
//           this.loadMoreButton.innerHTML = this.data.buttonText;
//           this.loadMoreButton.disabled = false;
//         } else {
//           if (this.loadMoreButton) this.loadMoreButton.remove();
//           console.log("No more products to load.");
//         }

//         // 🔄 refresh selectors in case DOM was replaced by filter/AJAX
//         this.refreshSelectors();

//         if (loaderElement) loaderElement.style.display = "none";
//       }
//     }.bind(this);

//     this.request.open("GET", this.nextPageUrl);
//     this.request.responseType = "document";
//     this.request.send();
//   }, 500);
// };

// // Destroy
// window.MeetAjaxForProduct.prototype.meetProductDestroy = function() {
//   if (this.loadMoreButton) {
//     this.loadMoreButton.removeEventListener("click", this.meetStopProductMultipleClicks);
//   }
//   return this;
// };
